// differentiates request calls between recs containers
export const requestKey = 'aGAQFG4j6QtVTSWqujfFYWeIU6BR5Mee';
export const subscriptionType = ['STYLE_AND_DECOR'];
export const pipCampaignId = '1381';
export const browseCampaignId = '1380';
export const pepCampaignId = '1380';
export const NTT_PREFIX = '/Ntt-';
